import { render, staticRenderFns } from "./storeSales.vue?vue&type=template&id=c36d1466&scoped=true&"
import script from "./storeSales.vue?vue&type=script&lang=js&"
export * from "./storeSales.vue?vue&type=script&lang=js&"
import style0 from "./storeSales.vue?vue&type=style&index=0&id=c36d1466&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36d1466",
  null
  
)

export default component.exports